import React from 'react';
import FriscoHistoryComponent from './FriscoHistoryComponent';

export default (props) => {
    return <FriscoHistoryComponent location={props.location} />;
}
